import React from 'react'
import LinePricetagAltIcon from 'components/Luxkit/Icons/line/LinePricetagAltIcon'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'

function getBannerText(variant: BannerProps['variant'], destName: string, discountPercent: number): string {
  switch (variant) {
    case 1:
      return `Save up to ${discountPercent}% on these great offers around ${destName}`
    case 2:
      return `We found limited-time offers in ${destName} - Save up to ${discountPercent}%`
    case 3:
      return `Good news! We found these exclusive offers around ${destName}`
    default:
      return ''
  }
}

interface BannerProps {
  destName: string;
  variant?: 1 | 2 | 3;
  discountPercent?: number;
}

function BannerForSuperSlimTile({ destName, variant = 3, discountPercent = 50 }: BannerProps) {
  const bannerText = getBannerText(variant, destName, discountPercent)
  return <MessageBanner
    kind="promotional-primary"
    icon={ <LinePricetagAltIcon />}
    description={<b>{bannerText}</b>}
  />
}

export default BannerForSuperSlimTile
